module.exports = __webpack_public_path__ + "static/media/HostingCloudLandingPage.29cc9383.jpeg";